import { QueryParams } from "~/api/v2/useDocumentReleases";

import { globalFilterParamKeys } from "./documentFilterUrlState";

export const librarySortParam = "sort";

const libraryViewParamKeys = [...globalFilterParamKeys, librarySortParam];

export const getLibraryViewStorageKey = (userId: number) =>
  `library:documentsList:filtersAndSorting:v1:user:${userId}`;

export const getLibraryViewPersistenceEnabledStorageKey = (userId: number) =>
  `library:documentsList:filtersAndSorting:enabled:user:${userId}`;

/** The subset of the URL that is persisted: filter and sort params. */
export const extractPersistableLibraryViewParams = (
  searchParams: URLSearchParams,
): URLSearchParams =>
  new URLSearchParams(
    [...searchParams].filter(([key]) => libraryViewParamKeys.includes(key)),
  );

/** True when the URL already states a library view (filters, sort or title search). */
export const hasExplicitLibraryViewState = (
  searchParams: URLSearchParams,
): boolean =>
  [...libraryViewParamKeys, QueryParams.Title].some((key) =>
    searchParams.has(key),
  );

export const readPersistedLibraryViewParams = (
  storageKey: string,
): URLSearchParams | undefined => {
  try {
    const serialized = localStorage.getItem(storageKey);
    if (!serialized) {
      return undefined;
    }
    const params = extractPersistableLibraryViewParams(
      new URLSearchParams(serialized),
    );
    return params.size > 0 ? params : undefined;
  } catch {
    return undefined;
  }
};

export const writePersistedLibraryViewParams = (
  storageKey: string,
  params: URLSearchParams,
) => {
  try {
    if (params.size > 0) {
      localStorage.setItem(storageKey, params.toString());
    } else {
      localStorage.removeItem(storageKey);
    }
  } catch {
    // Storage is best-effort; the URL remains the source of truth.
  }
};
